export default "__VITE_ASSET__DljO0HyC__"